import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=d5cf61aa"
import script from "./TableBase.vue?vue&type=script&lang=js"
export * from "./TableBase.vue?vue&type=script&lang=js"
import style0 from "./TableBase.vue?vue&type=style&index=0&id=d5cf61aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports